import { render, staticRenderFns } from "./CommercialApprovals.vue?vue&type=template&id=125d8a04&scoped=true"
import script from "./CommercialApprovals.vue?vue&type=script&lang=js"
export * from "./CommercialApprovals.vue?vue&type=script&lang=js"
import style0 from "./CommercialApprovals.vue?vue&type=style&index=0&id=125d8a04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125d8a04",
  null
  
)

export default component.exports